/**
 * identificacion.ts — los tipos de identificación que la base acepta.
 *
 * ▶ POR QUÉ ESTA LISTA EXISTE Y POR QUÉ ESTÁ SOLA
 *
 * La consola de operador tiene que preguntar el tipo, y hasta hoy no lo
 * preguntaba: la API mandaba `'02'` por omisión y **nadie lo elegía nunca**.
 * Eso no es un rótulo por defecto: el tipo **cambia la normalización de la
 * cédula**, porque cada uno tiene anchos de segmento distintos.
 *
 *     normalizar('01', '1-234-567')  →  102340567
 *     normalizar('02', '1-234-567')  →  otro número
 *
 * Una persona física dada de alta como sociedad queda con un número canónico
 * que no es el suyo, y eso no se ve: la empresa funciona igual y el problema
 * aparece el día que alguien la busca por cédula, o emite a su nombre.
 *
 * ▶ Y ESTÁ EN UN SOLO SITIO A PROPÓSITO
 *
 * `pruebas/idioma.test.ts` comprueba que esta lista sea EXACTAMENTE la de la
 * restricción `tipo_conocido` de la migración, y que cada valor tenga su
 * rótulo en los dos idiomas. Copiar la lista en el `<select>` la dejaría vieja
 * el día que la base acepte uno nuevo, y el desplegable seguiría ofreciendo
 * los de antes sin que nada se pusiera rojo.
 */

/** Los mismos que `constraint tipo_conocido` en `db/migraciones/0001_control.sql`. */
export const TIPOS_DE_IDENTIFICACION = ['01', '02', '03', '04', 'EX'] as const;

export type TipoDeIdentificacion = (typeof TIPOS_DE_IDENTIFICACION)[number];
